import React from "react";

// KpiCard: small label (uppercase by CSS) and number. `warn` uses the amber tokens and only applies when the
// value is greater than 0. With `onClick` the card is a toggle button that applies a filter (`pressed` when on).
export default function KpiCard({ label, value, warn = false, title, onClick, pressed = false }) {
  const loaded = value !== null && value !== undefined;
  const isWarn = warn && loaded && Number(value) > 0;
  const className = `crm-rollo__kpi${isWarn ? " crm-rollo__kpi--warn" : ""}`;

  const content = (
    <>
      <span className="crm-rollo__kpi-label">{label}</span>
      {loaded ? (
        <span className="crm-rollo__kpi-value">{value}</span>
      ) : (
        <span className="crm-rollo__kpi-value" aria-hidden="true">
          <span className="crm-rollo__skel crm-rollo__skel--kpi" />
        </span>
      )}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={`${className} crm-rollo__kpi--button`} title={title} aria-pressed={pressed} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <div className={className} title={title}>
      {content}
    </div>
  );
}
